import * as React from 'react'
import type { JSX } from 'react'

import type { SplitTrafficType } from './useSplit'
import { useSplitEnabled } from './useSplitEnabled'

type SplitProtectedProps = {
  name: string
  children: React.ReactNode
  attributes?: Record<string, unknown>
  variant?: string
  splitKey?: SplitIO.SplitKey
  trafficType?: SplitTrafficType
}

/**
 * Use this component to restrict part of the UI behind the split feature flag.
 *
 * @example
 * ```tsx
 * <SplitProtected name="mySplit">
 *  <MyComponent />
 * </SplitProtected>
 * ````
 */
const SplitProtected = ({
  name,
  children,
  attributes,
  variant,
  splitKey,
  trafficType,
}: SplitProtectedProps): JSX.Element | null => {
  const { isEnabled } = useSplitEnabled(name, {
    attributes,
    enabledTreatment: variant,
    splitKey,
    trafficType,
  })

  if (isEnabled) {
    return <>{children}</>
  }

  return null
}

export { SplitProtected }
export type { SplitProtectedProps }
